import React from "react";
import AppRoutes from "./routes/Routes";
import { FloatingWhatsApp } from "react-floating-whatsapp2";

const App = () => {
  return (
    <div>
      <AppRoutes />
      <FloatingWhatsApp
        phoneNumber="+5491160282658"
        accountName="Upgrade Turismo"
        chatMessage={"Hola! Dejanos tu consulta?.\nEstamos para ayudarte"}
        statusMessage={"Tipicamente responde en 15 minutos"}
        allowEsc
        allowClickAway
        openChatOnClick
        avatar={"assets/img/upgradeLogo.jpg"}
        placeholder={"Escribi tu mensaje"}
      />
    </div>
  );
};

export default App;
